import { useQueryClient } from '@tanstack/react-query';
import { App, Flex } from 'antd';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { buildTimeline } from '~/helpers/conversation';
import { useDeleteNote } from '~/hooks/useConversations';

import ClosedBanner from './ClosedBanner';
import MessageBubble from './MessageBubble';
import './Messages.scss';
import NoteCard from './NoteCard';

function Messages({ conversationId, messages, merchantName, notes = [], closingEvents = null }) {
  const { notification } = App.useApp();
  const queryClient = useQueryClient();
  const { id: userId, admin: isAdmin } = useSelector((state) => state.session.user);
  const deleteNoteMutation = useDeleteNote(conversationId, queryClient);
  const timeline = useMemo(() => buildTimeline(messages, notes, closingEvents), [messages, notes, closingEvents]);

  const handleDeleteNote = (noteId) => {
    deleteNoteMutation.mutate(noteId, {
      onError: (error) => {
        notification.open({
          className: 'notification-dialogue-error',
          message: error.message,
        });
      },
    });
  };

  return (
    <div className='w-full flex flex-col-reverse h-full overflow-y-scroll'>
      <Flex vertical gap={16}>
        {timeline.map((item, index) => {
          if (item.kind === 'note' && item.content) {
            const canDelete = isAdmin || (item.author_id && item.author_id === userId);
            return <NoteCard key={`note-${item.id}`} note={item} canDelete={canDelete} onDelete={handleDeleteNote} />;
          }
          if (item.kind === 'closed') {
            return <ClosedBanner key={`closed-${index}`} merchantName={merchantName} event={item} />;
          }
          return <MessageBubble key={`msg-${index}`} message={item} conversationId={conversationId} />;
        })}
      </Flex>
    </div>
  );
}

export default Messages;
